import JCE from '@chesscom/js-chess-engine';

/**
 * Finds the indexes of the repeated plys in a line drawn by threefold repetition.
 * Returns null if threefold repetition not detected.
 */
export function findThreefoldRepetitions(line: JCE.Line): number[] | null {
  if (!line) {
    return null;
  }

  // only include first 3 terms of fen for detecting repetitions
  // (position, color to move, castling rights)
  const fens = line.map(({ fen }) => JCE.shortenFen(fen, 3));
  const indices = findThreefoldIndexes(fens);

  return indices.length === 3 ? indices : null;
}

/**
 * Get repeat fen indexes
 */
function findThreefoldIndexes(fens: string[]): number[] {
  const indices: number[] = [];

  // iterate backwards over fens array to find repetitions
  for (let i = fens.length - 1; i >= 0; i--) {
    if (fens[i] === fens[fens.length - 1]) {
      indices.push(i);
    }

    if (indices.length === 3) {
      return indices;
    }
  }

  return indices;
}
